export default {
	MUTE: 'mute',
	THEME: 'theme',
};
